import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ScreenStyles } from './ForestIntro.styles';

const ASSETS_PATH = `${S3_BUCKET_URL}/layout-own-ai-multigender-forest/forest-intro`;

export const ScreenForestIntro: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'ForestIntro',
      });
    }
  }, []);

  const { user } = useAccount();

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();

  const gender = form.watch('gender') || user?.onboarding_data.gender;

  const handleContinue = () => {
    nextStepTimeout(wizard.nextStep);
  };

  const bgImageSrc = `${ASSETS_PATH}/${gender}.jpg`;

  return (
    <ScreenStyles
      background="dark-solid"
      bgImage={<img src={bgImageSrc} alt="Forest" />}
      bgImageMask={true}
    >
      <IonContent>
        <div className="content-wrapper">
          <OwnAiTitle className="local-title">
            In the quiet of the forest, something begins...
          </OwnAiTitle>
        </div>
      </IonContent>

      <OnboardingFooter
        onContinue={handleContinue}
        buttonText="Follow the path"
      />
    </ScreenStyles>
  );
};
